import   axios,
       { AxiosInstance,
         AxiosRequestConfig,
         AxiosPromise }                     from 'axios';

export class HttpService {

    // the inner properties of this service
    private axiosApiInstance: AxiosInstance;

    // define default headers
    private defaultHeaders: any;

    /**
     * Constructor of HttpService.
     *
     * @param baseApiURL - The Base server APIs URL to use.
     * @param timeout - The Requests timeout to use on each request.
     * @param headerParams - The header parameters to use par default.
     * @param withCredentials - Indicates whether the credentials should be configured or not.
     */
    constructor(private readonly baseApiURL: string,
                private readonly timeout: number,
                private readonly headerParams?: any,
                private readonly withCredentials?: boolean) {

        const credential: boolean = (this.withCredentials === undefined) ? false : this.withCredentials;
        
        this.axiosApiInstance = axios.create({
                                                baseURL: this.baseApiURL,
                                                timeout: this.timeout,
                                                withCredentials: credential
                                             });

        this.defaultHeaders = this.headerParams ? this.headerParams : { 
                                                                        'Content-Type': 'application/json; charset=utf-8', 
                                                                        'Accept': 'application/json' 
                                                                      };
    }

    /**
     * Wrapper for GET request to server API calls.
     *
     * @param path Context path to the target service.
     * @param headers No mandatory specific headers to use for this request, default value will be used
     *                when no provided.
     */
    public get(path: string, headers?: AxiosRequestConfig) {
        const useHeaders: AxiosRequestConfig = headers ? headers : {headers: this.defaultHeaders};
        return this.axiosApiInstance.get(path, useHeaders);
    }

    /**
     * Wrapper for POST request to server API calls.
     *
     * @param path Context path to the target service.
     * @param params Service parameters to send.
     * @param headers No mandatory specific headers to use for this request, default value will be used
     *                when no provided.
     */
    public post(path: string, params?: any, headers?: AxiosRequestConfig): AxiosPromise<any> {
        const useHeaders: AxiosRequestConfig = headers ? headers : {headers: this.defaultHeaders};
        return this.axiosApiInstance.post(path, params, useHeaders);
    }

    /**
     * Wrapper for PUT request to server API calls.
     *
     * @param path Context path to the target service.
     * @param params Service parameters to send.
     * @param headers No mandatory specific headers to use for this request, default value will be used
     *                when no provided.
     */
    public put(path: string, params?: any, headers?: AxiosRequestConfig): AxiosPromise<any> {
        const useHeaders: AxiosRequestConfig = headers ? headers : {headers: this.defaultHeaders};
        return this.axiosApiInstance.put(path, params, useHeaders);
    }

    /**
     * Wrapper for DELETE request to server API calls.
     *
     * @param path Context path to the target service.
     * @param params Service parameters to send.
     */
    public delete(path: string, params?: any): AxiosPromise<any> {
        return this.axiosApiInstance.delete(path, params);
    }
}
